import { SVGProps } from "react";

interface LoadingSearchProps extends SVGProps<SVGSVGElement> {
  strokeWidth?: number;
}

const LoadingSearch: React.FC<LoadingSearchProps> = ({
  strokeWidth = 16,
  ...props
}) => {
  return (
    <svg
      viewBox="-200 -200 400 400"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <circle
        cx="0"
        cy="0"
        fill="none"
        r="175"
        strokeWidth={strokeWidth}
        stroke="#C74601"
        strokeDasharray="1400 1400"
        transform="rotate(-90)"
      >
        <animate
          attributeName="stroke-dashoffset"
          from="2800"
          to="0"
          dur="2.4s"
          repeatCount="indefinite"
          begin="0.3s"
        />
      </circle>
    </svg>
  );
};

export default LoadingSearch;
